/**
 * Copy for the export controls (SPEC §19; EXIT-5, EXIT-6).
 *
 * **The button's own label is a prop; everything structural is here.** The two
 * callers export different things and have to say so — "Export manifest",
 * "Export audit log" — but what happens after the click is one behaviour, and a
 * second copy of "Preparing…" is a second sentence to keep in step.
 */
export const EXPORT_BUTTON_COPY = {
  pending: 'Preparing…',
  /**
   * Says **two files**, because that is the surprise. EXIT-5 delivers the pair
   * from one act, so a reader who expected one download needs telling that the
   * second is not a double-click of theirs.
   */
  done: (rows: number) =>
    `Downloaded ${String(rows)} ${rows === 1 ? 'row' : 'rows'} as two files: CSV and JSON.`,
  /** An export of nothing is still a document, and saying so beats silence. */
  doneEmpty: 'Downloaded two empty files. There was nothing to export.',
  /**
   * The fallback only. `messageFrom` prefers the API's own line, which for the
   * ceiling refusal names Blue Partner — the remedy, and the thing a generic
   * sentence would throw away.
   */
  error: 'The export could not be generated. Try again.',
} as const;
